import { useNavigate } from 'react-router-dom';
import { Search, Wallet } from 'lucide-react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { useState, useEffect } from 'react';
import api from '@/lib/api';

const sora = { fontFamily: 'Sora, sans-serif' };

export default function DesktopHeader() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    api.get('/auth/me').then(r => setUser(r.data)).catch(() => {});
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    // Search functionality placeholder
  };

  return (
    <header
      data-testid="desktop-header"
      className="hidden lg:flex items-center gap-4 px-5 py-2.5 sticky top-0 z-50"
      style={{ background: '#0a0a0a', borderBottom: '1px solid #1a1a1a', ...sora }}
    >
      {/* Logo */}
      <button onClick={() => navigate('/')} className="flex items-center gap-2 shrink-0">
        <img src="/logo.png" alt="Bisne" className="h-8 w-8 object-contain" />
        <span className="text-base font-bold" style={{ color: '#f5c518' }}>Bisne</span>
      </button>

      {/* Search */}
      <form onSubmit={handleSearch} className="flex-1 max-w-md">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: '#555' }} />
          <input
            data-testid="desktop-search"
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="Buscar en Ocoyoacac..."
            className="w-full pl-10 pr-4 py-2 rounded-full text-sm outline-none"
            style={{ background: '#111', border: '1px solid #1a1a1a', color: '#d5d5d5', fontFamily: 'Sora, sans-serif' }}
          />
        </div>
      </form>

      <div className="flex-1" />

      {/* Wallet + Avatar */}
      <div className="flex items-center gap-3">
        {user && (
          <button onClick={() => navigate('/profile')}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full"
            style={{ background: '#111', border: '1px solid #1a1a1a' }}>
            <Wallet className="w-3.5 h-3.5" style={{ color: '#f5c518' }} />
            <span className="text-xs font-semibold" style={{ color: '#f5c518' }}>${user.bisne_cash || 0} BC</span>
          </button>
        )}
        {user ? (
          <button onClick={() => navigate('/profile')}>
            <Avatar className="w-8 h-8" style={{ border: '2px solid #1a1a1a' }}>
              <AvatarImage src={user.picture} />
              <AvatarFallback style={{ background: '#1a1a1a', color: '#d5d5d5', fontSize: 12, fontFamily: 'Sora, sans-serif' }}>{user.name?.charAt(0)}</AvatarFallback>
            </Avatar>
          </button>
        ) : (
          <button onClick={() => navigate('/login')}
            className="px-4 py-1.5 rounded-full text-xs font-semibold"
            style={{ background: '#f5c518', color: '#000', fontFamily: 'Sora, sans-serif' }}>
            Entrar
          </button>
        )}
      </div>
    </header>
  );
}
